import React, { Component } from 'react';
import sectiondata from '../../data/sections.json';

class Team extends Component {
  state = {
    loading: true,
    data: null,
  };

  componentDidMount() {
    // Simulate API call / async loading
    setTimeout(() => {
      this.setState({ data: sectiondata.team, loading: false });
    }, 1000); // 1 second delay just for demo
  }

  render() {
    let publicUrl = process.env.PUBLIC_URL + '/';
    let { loading, data } = this.state;

    if (loading) {
      return (
        <div className="team-area text-center pd-top-90 pd-bottom-70">
          <div className="container">
            <h4>Loading...</h4>
            {/* Or you can use a spinner instead of text */}
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="team-area bg-gray mg-top-70 pd-top-90 pd-bottom-70">
        <div className="container">
          <div className="section-title text-center">
            <h2 className="title">{data.title}</h2>
          </div>
          <div className="row">
            {/* {data.items.map((item, i) => ( */}
            {data.items
  .filter(item => item.isActive !== false)
  .map((item, i) => (

              <div key={i} className="col-lg-3 col-sm-6">
                <div className="single-team">
                  <div className="thumb">
                    <img src={publicUrl + item.image} alt="team" />
                  </div>
                  <div className="team-details">
                    <h5>{item.name}</h5>
                    <span>{item.designation}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Team;
